import React from 'react';
import { Drawer, Timeline, Avatar, Tabs, Select, Input, Button, Layout, Menu, Icon, Row, Col, Table, Divider } from 'antd';
import ReactCodeMirror from '@skidding/react-codemirror';
import CodeMirror from 'codemirror';
import 'codemirror/mode/javascript/javascript';
import 'codemirror/mode/markdown/markdown';
import 'codemirror/keymap/sublime';
import 'codemirror/addon/display/placeholder';
import 'codemirror/addon/comment/comment';
import 'codemirror/addon/comment/continuecomment';
import 'codemirror/addon/edit/matchbrackets';
import 'codemirror/addon/edit/closebrackets';
import 'codemirror/addon/selection/active-line';
import 'codemirror/addon/search/match-highlighter';
import 'codemirror/addon/hint/show-hint.css';
import 'codemirror/addon/hint/show-hint';

import './vbql.less';

import './vbql/mode';
import './vbql/hint';
import './vbql/prediction';

const hintRefRe = new RegExp('#\\b(\\w*)\\b');
const modeRefRe = new RegExp('^#(\\w*)');

const codeOptions = {
  mode: 'text/x-vbql',
  theme: 'hipster',
  highlightSelectionMatches: {
    trim: true,
  },
  lineWrapping: true,
  extraKeys: {
    'Cmd-Enter': () => console.log('test'),
    'Ctrl-Enter': () => console.log('test'),
    'Ctrl-Space': 'autocomplete',
  },
  autoCloseBrackets: true,
  lineNumbers: true,
  matchBrackets: true,
  addModeClass: true,
  refRe: modeRefRe,
  placeholder: 'Enter a VBQL query here.',
  showPredictions: true,
  hintOptions: {
    hint: CodeMirror.hint.vbql,
    refRe: hintRefRe,
    tables: [],
  },
  keyMap: 'sublime',
};

const mdOptions = {
  mode: 'markdown',
  keyMap: 'sublime',
  lineWrapping: true,
  theme: 'md',
  placeholder: 'Type Markdown here...',
  showPredictions: false,
};

const noop = () => {};

class VBQLArea extends React.Component {
  render() {
    const { inline = true, readonly, value, onChange = noop, onRun = noop } = this.props;
    const css = `vbql-area ${readonly ? 'vbql-area--readonly' : ''} ${inline ? 'vbql-area--inline' : ''}`;
    let configuredOptions;

    if (readonly) {
      configuredOptions = {
        ...codeOptions,
        readOnly: true,
      };
    } else {
      configuredOptions = {
        ...codeOptions,
        extraKeys: {
          ...codeOptions.extraKeys,
          'Cmd-Enter': onRun,
          'Ctrl-Enter': onRun,
        },
      };
    }

    return (
      <ReactCodeMirror
        key="a"
        className={css}
        value={value}
        onChange={onChange}
        options={configuredOptions}
      />
    );
  }
}

export default VBQLArea;
// padding: '54px 101px 65px 201px',
